export const SET_CURRENT_COLLECTION_TAG = 'SET_CURRENT_COLLECTION_TAG';
